export default __webpack_public_path__ + "static/media/img-login-left.fee4bd17.png";